<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户id" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="用户id"></el-input>
      </el-form-item>
          <el-form-item label="公司ID" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司ID"></el-input>
      </el-form-item>
          <el-form-item label="下游产品ID" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="下游产品ID"></el-input>
      </el-form-item>
          <el-form-item label="推送内容" prop="content">
          <el-input v-model="dataForm.content" placeholder="推送内容"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="是否已推送1是0否" prop="isPush">
          <el-input v-model="dataForm.isPush" placeholder="是否已推送1是0否"></el-input>
      </el-form-item>
          <el-form-item label="推送返回状态码" prop="pushCode">
          <el-input v-model="dataForm.pushCode" placeholder="推送返回状态码"></el-input>
      </el-form-item>
          <el-form-item label="推送返回信息" prop="pushMsg">
          <el-input v-model="dataForm.pushMsg" placeholder="推送返回信息"></el-input>
      </el-form-item>
          <el-form-item label="推送时间" prop="pushDate">
          <el-input v-model="dataForm.pushDate" placeholder="推送时间"></el-input>
      </el-form-item>
              <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item>
          <el-form-item label="状态（1有效、0无效）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（1有效、0无效）"></el-input>
      </el-form-item>
          <el-form-item label="0未回访1有效2无效" prop="type">
          <el-input v-model="dataForm.type" placeholder="0未回访1有效2无效"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        customerId: '',
        companyId: '',
        productId: '',
        content: '',
        remark: '',
        isPush: '',
        pushCode: '',
        pushMsg: '',
        pushDate: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: '',
        type: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        customerId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isPush: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/channelcallback/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/channelcallback/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
